/**
 * Marker on the header tasks/chat toggle so `PrivateWorkspaceAgentPanelRoot` can restore focus after
 * `pendingFocus === 'panel'` when switching to the tasks view. Shared so a rename cannot break focus rescue.
 */
export const WORKSPACE_AGENT_TASKS_TOGGLE_FOCUS_ATTRIBUTE = 'data-workspace-agent-tasks-toggle-focus';
